"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kpi = void 0;
var Kpi_1 = require("./Kpi");
Object.defineProperty(exports, "Kpi", { enumerable: true, get: function () { return Kpi_1.Kpi; } });
//# sourceMappingURL=index.js.map